import React from 'react';
import { Nav } from 'react-bootstrap';

const About = () => {
  return (
    <div id="about">
      <h2>What IS In The Box</h2>
      <h5>
        The 5 piece powerhouse rock band, <strong>What's In The Box</strong>, is NY’s tribute to the chart topping classics of ‘90s alternative music. Every performance is a nostalgic time warp through the gritty anthems that shaped a generation. 
      </h5>
      <br></br>
      <h5> 
        Since forming in 2023, WITB has been dialing in the <strong>defining sounds of the grunge era</strong>. Holding down the rhythm section are Nikko Cocciolillo on bass and Steven DeLitta behind the drums, delivering pulse-pounding grooves that make you wanna move. Frontman Pete Repole’s raw, soul-cutting vocals ride the melodic wave carved by guitarists PJ Angarano and Walter Bianco. Come check out a gig as they crush through the tones of <strong>Soundgarden, Alice In Chains, Stone Temple Pilots, The Smashing Pumpkins, Pearl Jam, Nirvana, and many MANY more timeless acts</strong>.
      </h5>
      <br></br> 
      <h5 class="tagline">
        ~ We are <strong>What’s In The Box</strong> ~
        <br></br> 
        A tribute to the raw spirit of 90s alternative music
      </h5>

      
    </div>
  );
};

export default About;